
export default function ValidationsUnidadeGerencia() {

    const validateEmail = (emails) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const errors = {};

        if (!emailRegex.test(emails.emailGerente)) {
            errors.emailGerente = "O E-mail do Gerente é inválido.";
        }
        if (!emailRegex.test(emails.emailEncarregado)) {
            errors.emailEncarregado = "O E-mail do Encarregado é inválido.";
        }
        if (
            emails.emailGerente &&
            emails.emailEncarregado &&
            emails.emailGerente.trim().toLowerCase() === emails.emailEncarregado.trim().toLowerCase()
        ) {
            errors.emailsIguais = "O E-mail do Gerente não pode ser igual ao E-mail do Encarregado.";
        }

        return errors;
    };

    const validateFields = (fields) => {
        const {
            nome,
            sigla,
            numero,
            selectedOptionTypeRegistration,
            selectedOptionGO,
            selectedOptionPorte,
        } = fields;
        const errors = {};

        if (!nome.trim()) errors.nome = "O campo Nome é obrigatório.";
        
        if (!sigla.trim()) {
            errors.sigla = "O campo Sigla é obrigatório.";
        } else if (sigla.trim().length !== 3) {
            errors.sigla = "O campo Sigla deve conter exatamente 3 letras.";
        }

        if (numero == null || numero === '') errors.numero = "O campo Número é obrigatório.";
        if (!selectedOptionTypeRegistration) errors.tipoCadastro = "O Tipo de Cadastro é obrigatório.";

        // Para os campos selecionáveis (GO e Porte)
        if (selectedOptionTypeRegistration?.value === "UNIDADE") { // Apenas para Unidade
            if (!selectedOptionGO) errors.go = "O campo GO é obrigatório.";
            if (!selectedOptionPorte) errors.porte = "O campo Porte é obrigatório.";
        }

        return errors;
    };

    return {
        validateEmail,
        validateFields
    }
}